export default __webpack_public_path__ + "static/media/medical.7e35fd8d.png";